import React, {useContext, useMemo} from "react";
import {Tooltip} from "@mui/material";
import {CampaignItemContext} from "../../../core/context/context";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import useSecondTicker from "../../../core/hooks/useSecondTicker";

// utcOffset() требует плагин utc; раньше он подключался только побочным импортом из других модулей
dayjs.extend(utc);

const formatdate = (timestamp) => {
    let d = dayjs(timestamp * 1000).utcOffset(180).format('YYYY-MM-DD HH:mm:ss')
    return d;
}

export const getTimeLeft = (targetDate, now = Date.now()) => {
    const timeDifference = targetDate * 1000 - now;

    if (timeDifference <= 0) {
        return "0d 00:00:00";
    }

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    return `${days}d ${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
}

// Тикает только сам текст обратного отсчёта (Tooltip и карточка не перерисовываются),
// и только пока цель в будущем — прошедшие кампании таймер не держат.
const Countdown = ({target}) => {
    const now = Date.now();
    useSecondTicker(target * 1000 > now);
    return getTimeLeft(target, now);
}

const CampaignItemTimeleft = ({item, showDetails, showRainbow}) => {
    const {campaigns, types} = useContext(CampaignItemContext)

    const campaignType = useMemo(
        () => types?.[item.type] ?? campaigns.types.filter(_ct => _ct.readableType == item.type)[0],
        [item.type, types, campaigns.types]
    )

    const timeClassName = useMemo(() => {
        if (!showRainbow) return '';
        if (campaignType == null) return '';

        let current_time = new Date().getTime() / 1000;

        if (current_time < (item.distribution.from - campaignType.announceDuration)) return 'aqua';
        if (
            current_time >= (item.distribution.from - campaignType.announceDuration) &&
            current_time < item.distribution.from
        ) return 'lightgreen';
        if (
            current_time >= item.distribution.from &&
            current_time < item.distribution.till
        ) return 'green';
        if (
            current_time >= item.distribution.till &&
            current_time < (item.distribution.till + campaignType.extraDuration)
        ) return 'yellow';
        if (current_time >= (item.distribution.till + campaignType.extraDuration)) return 'red';

        return '';
    }, [showRainbow, campaignType, item.distribution]);

    const isPermanent = item.distribution.till == '32503680000'
    const hasType = campaignType != null

    return (
        <>

                <div className={"campaign-timewrap "+ timeClassName}>
                    <div className="campaign-timeblock">
                        <div className="campaign-item__starttime">
                            <Tooltip
                                title="Main Phase From">
                                <span>{formatdate(item.distribution.from)}</span>
                            </Tooltip>
                        </div>
                        <div className="campaign-item__countdown-timer">
                            <Tooltip
                                title="Timeleft before Main Phase">
                                <span>{hasType && <Countdown target={item.distribution.from}/>}</span>
                            </Tooltip>
                        </div>
                        {showDetails &&
                            <>
                                <div className="campaign-item__starttime">
                                    <Tooltip
                                        title="Announce From">
                                        <span>{formatdate(item.distribution.from - campaignType?.announceDuration)}</span>
                                    </Tooltip>
                                </div>
                                <div className="campaign-item__countdown-timer">
                                    <Tooltip
                                        title="Timeleft before Announce">
                                        <span>{hasType && <Countdown target={item.distribution.from - campaignType.announceDuration}/>}</span>
                                    </Tooltip>
                                </div>
                            </>
                        }

                    </div>

                    <div className="campaign-timeblock">

                        <div className="campaign-item__endtime">
                            <Tooltip
                                title="Main Phase Till">
                                <span>{formatdate(item.distribution.till)}</span>
                            </Tooltip>
                        </div>
                        <div className="campaign-item__countdown-timer">
                            <Tooltip
                                title="Timeleft before Main Phase">
                                <span>{!isPermanent ? (hasType && <Countdown target={item.distribution.till}/>) : <>-</>}</span>
                            </Tooltip>
                        </div>
                        {showDetails&&!isPermanent &&
                            <>
                                <div className="campaign-item__endtime">
                                    <Tooltip
                                        title="Extra Time Till">
                                        <span>{formatdate(item.distribution.till + campaignType?.extraDuration)}</span>
                                    </Tooltip>
                                </div>
                                <div className="campaign-item__countdown-timer">
                                    <Tooltip
                                        title="Timeleft left before Extra Time">
                                        <span>{hasType && <Countdown target={item.distribution.till + campaignType.extraDuration}/>}</span>
                                    </Tooltip>
                                </div>
                            </>
                        }

                    </div>
                    {showDetails&&<div style={{"clear":"both"}}>Distribution type: <b>{item.distribution.type}</b></div>}

                </div>

        </>
    )

}

export default React.memo(CampaignItemTimeleft);
